import { InvoiceBase } from './base-classes/invoice-base'

const invoiceBase = new InvoiceBase()

invoiceBase.state.all.defaultFilter = {
  customerName: null,
  projectCode: null,
  projectOwnerUserInitials: null,
  orderByColumn: 'serialNumber',
  orderByDescending: true,
  invoiceType: null,
  status: null
}

export const invoicesArchive = {
  namespaced: true,
  state: invoiceBase.state,
  actions: invoiceBase.actions(),
  mutations: invoiceBase.mutations(),
  getters: invoiceBase.getters()
}



// WEBPACK FOOTER //
// ./src/store/invoice-archive.module.js